'use client';

import { PaymentSummary } from '../../PaymentSummary/PaymentSummary';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

/**
 * Renders the payment summary and opens the cancel auto-renewal modal.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsPayment() {
  const { ticket, hasRenewal, effectiveCancelReceiptAt, openCancelModal } = usePurchaseDetails();
  const { renewType, ticketState, participationInfo, activeSince } = ticket;

  return (
    <PaymentSummary
      hasRenewal={hasRenewal}
      renewType={renewType}
      cancelReceiptAt={effectiveCancelReceiptAt}
      ticketState={ticketState}
      lastDrawingDate={participationInfo.at(-1)?.drawingDate}
      activeSince={activeSince}
      onCancelClick={openCancelModal}
    />
  );
}

export { PurchaseDetailsPayment };
